/** List of available SlickGrid Extensions (Controls & Plugins) */
export var ExtensionName;
(function (ExtensionName) {
    ExtensionName["autoTooltip"] = "autoTooltip";
    ExtensionName["cellExternalCopyManager"] = "cellExternalCopyManager";
    ExtensionName["cellMenu"] = "cellMenu";
    ExtensionName["checkboxSelector"] = "checkboxSelector";
    ExtensionName["columnPicker"] = "columnPicker";
    ExtensionName["contextMenu"] = "contextMenu";
    ExtensionName["customTooltip"] = "customTooltip";
    ExtensionName["draggableGrouping"] = "draggableGrouping";
    ExtensionName["groupItemMetaProvider"] = "groupItemMetaProvider";
    ExtensionName["gridMenu"] = "gridMenu";
    ExtensionName["headerButton"] = "headerButton";
    ExtensionName["headerMenu"] = "headerMenu";
    ExtensionName["rowDetailView"] = "rowDetailView";
    ExtensionName["rowMoveManager"] = "rowMoveManager";
    ExtensionName["rowSelection"] = "rowSelection";
})(ExtensionName || (ExtensionName = {}));
//# sourceMappingURL=extensionName.enum.js.map